import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BundlesApi - axios parameter creator
 * @export
 */
const BundlesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [type] 3 (Bundle) or 4 (Giftbox); all when empty
         * @param {boolean} [isActive] Only bundles that apply at checkout (true) or that do not (false); all when empty
         * @param {number} [containsProductId] Only bundles with a row for this product
         * @param {boolean} [hasContents] Only bundles with (true) or without (false) contents rows
         * @param {number} [skip] Page start
         * @param {number} [take] Page size; all when empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (type, isActive, containsProductId, hasContents, skip, take, options = {}) => {
            const localVarPath = `/v1/Bundles/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }
            if (containsProductId !== undefined) {
                localVarQueryParameter['containsProductId'] = containsProductId;
            }
            if (hasContents !== undefined) {
                localVarQueryParameter['hasContents'] = hasContents;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id] The Bundle/Giftbox product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Bundles/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {BundleAdminSaveRequest} [BundleAdminSaveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (BundleAdminSaveRequest, options = {}) => {
            const localVarPath = `/v1/Bundles/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BundleAdminSaveRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BundlesApi - functional programming interface
 * @export
 */
const BundlesApiFp = function (configuration) {
    const localVarAxiosParamCreator = BundlesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [type] 3 (Bundle) or 4 (Giftbox); all when empty
         * @param {boolean} [isActive] Only bundles that apply at checkout (true) or that do not (false); all when empty
         * @param {number} [containsProductId] Only bundles with a row for this product
         * @param {boolean} [hasContents] Only bundles with (true) or without (false) contents rows
         * @param {number} [skip] Page start
         * @param {number} [take] Page size; all when empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(type, isActive, containsProductId, hasContents, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(type, isActive, containsProductId, hasContents, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BundlesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id] The Bundle/Giftbox product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BundlesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {BundleAdminSaveRequest} [BundleAdminSaveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(BundleAdminSaveRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(BundleAdminSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BundlesApi.save']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BundlesApi - factory interface
 * @export
 */
const BundlesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BundlesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [type] 3 (Bundle) or 4 (Giftbox); all when empty
         * @param {boolean} [isActive] Only bundles that apply at checkout (true) or that do not (false); all when empty
         * @param {number} [containsProductId] Only bundles with a row for this product
         * @param {boolean} [hasContents] Only bundles with (true) or without (false) contents rows
         * @param {number} [skip] Page start
         * @param {number} [take] Page size; all when empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(type, isActive, containsProductId, hasContents, skip, take, options) {
            return localVarFp.getAll(type, isActive, containsProductId, hasContents, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id] The Bundle/Giftbox product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {BundleAdminSaveRequest} [BundleAdminSaveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(BundleAdminSaveRequest, options) {
            return localVarFp.save(BundleAdminSaveRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BundlesApi - object-oriented interface
 * @export
 * @class BundlesApi
 * @extends {BaseAPI}
 */
class BundlesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [type] 3 (Bundle) or 4 (Giftbox); all when empty
     * @param {boolean} [isActive] Only bundles that apply at checkout (true) or that do not (false); all when empty
     * @param {number} [containsProductId] Only bundles with a row for this product
     * @param {boolean} [hasContents] Only bundles with (true) or without (false) contents rows
     * @param {number} [skip] Page start
     * @param {number} [take] Page size; all when empty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundlesApi
     */
    getAll(type, isActive, containsProductId, hasContents, skip, take, options) {
        return BundlesApiFp(this.configuration).getAll(type, isActive, containsProductId, hasContents, skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id] The Bundle/Giftbox product id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundlesApi
     */
    getById(id, options) {
        return BundlesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {BundleAdminSaveRequest} [BundleAdminSaveRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundlesApi
     */
    save(BundleAdminSaveRequest, options) {
        return BundlesApiFp(this.configuration).save(BundleAdminSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export { BundlesApi, BundlesApiAxiosParamCreator, BundlesApiFactory, BundlesApiFp };
//# sourceMappingURL=bundles-api.js.map
